<template>
  <!-- <div class="sidebar-footer"></div> -->
</template>
<script>
/* eslint-disable */
export default {
  name: 'sidebar-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarFooter.vue